import React from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  RedditIcon,
  RedditShareButton,
} from 'react-share';
import './DonationWidget.css';

const DonationWidget = () => {
  const url = 'https://liftourvoices.org/ai-analysis-tool';
  const title = 'Lift Our Voices';

  return (
    <div className="donation-form">
      <div className="donation-share-container">
        <div className="donate-section">
          {/* Logo */}
          <img
            src="/LOVLogo.png"
            alt="Lift Our Voices Logo"
            className="lov-logo"
          />

          {/* Donation Section */}
          <h3 className="header-donation">
            Do you feel more empowered with this information? Make a donation!
          </h3>
          <a
            className="donation-button"
            href="https://www.every.org/lift-our-voices-ec18?donateTo=lift-our-voices-ec18#/donate/card"
            target="_blank"
            rel="noopener noreferrer"
          >
            Donate
          </a>
        </div>

        {/* Share Section */}
        <div className="share-container">
          <h3>Share this tool:</h3>
          <div
            className="share-buttons"
            role="group"
            aria-label="Share this tool"
          >
            <FacebookShareButton url={url} quote={title}>
              <FacebookIcon size={32} round />
            </FacebookShareButton>

            <LinkedinShareButton url={url} title={title}>
              <LinkedinIcon size={32} round />
            </LinkedinShareButton>

            <FacebookMessengerShareButton url={url} appId="your_facebook_app_id">
              <FacebookMessengerIcon size={32} round />
            </FacebookMessengerShareButton>

            <TwitterShareButton url={url} title={title}>
              <TwitterIcon size={32} round />
            </TwitterShareButton>

            <WhatsappShareButton url={url} title={title}>
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>

            <RedditShareButton url={url} title={title}>
              <RedditIcon size={32} round />
            </RedditShareButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationWidget;
